module.exports = __webpack_public_path__ + "static/img/tst2-06.87d7d28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-06.jpg
// module id = hsEQ
// module chunks = 1